/**
 * Asynchronously loads MonthlyRoadmap when the monthly timeline view is active.
 */

import React from 'react';
import { lazyLoad } from 'utils/loadable';
import { Loader } from 'app/components/Loader';

export const MonthlyRoadmap = lazyLoad(
  () => import('./MonthlyRoadmap'),
  module => module.MonthlyRoadmap,
  { fallback: <Loader /> }
);
